import { faCubes, faFile, faHourglass, faRoute, faTimeline } from "@fortawesome/pro-duotone-svg-icons";
import { CharterType } from "__generated__/graphql";
import { getMultiValuesField } from "components/utils/Permission";
import { CharterSubtype } from "__generated__/enums";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const getCharterIcon = (charterType, charterSubtype, size) => {
	switch (charterType) {
		case CharterType.Sales: {
			switch (charterSubtype) {
				case CharterSubtype.Spot:
					return <FontAwesomeIcon className={"charter-SpotSalesCharter-icon"} icon={faCubes} size={size} />;
				case CharterSubtype.Time:
					return <FontAwesomeIcon className={"charter-TimeSalesCharter-icon"} icon={faTimeline} size={size} />;
				case CharterSubtype.Contract:
					return <FontAwesomeIcon className={"charter-ContractSalesCharter-icon"} icon={faFile} size={size} />;
				case CharterSubtype.Supplier:
					return <FontAwesomeIcon className={"charter-ContractSalesCharter-icon"} icon={faFile} size={size} />;
				default:
					return undefined;
			}
		}
		case CharterType.Purchase: {
			switch (charterSubtype) {
				case CharterSubtype.Spot:
					return <FontAwesomeIcon className={"charter-SpotPurchaseCharter-icon"} icon={faRoute} size={size} />;
				case CharterSubtype.Time:
					return <FontAwesomeIcon className={"charter-TimePurchaseCharter-icon"} icon={faHourglass} size={size} />;
				case CharterSubtype.Contract:
					return <FontAwesomeIcon className={"charter-ContractPurchaseCharter-icon"} icon={faFile} size={size} />;
				case CharterSubtype.Supplier:
					return <FontAwesomeIcon className={"charter-ContractPurchaseCharter-icon"} icon={faFile} size={size} />;
				default:
					return undefined;
			}
		}
	}
};

export const formatCharterForMutation = ({ id, charterNumber, type, subtype, creditor, debtor, broker, contract, ...c }, relationType) => {
	return {
		id,
		charterNumber,
		type: type,
		subtype: subtype,
		creditor: { id: creditor.id },
		debtor: { id: debtor.id },
		contract: id ? undefined : contract,
		relationType: relationType,
		broker: broker ? { id: broker.id } : null,
		validFrom: c.validFrom,
		validUntil: c.validUntil,
		minimumShipNominationDays: c.minimumShipNominationDays,
		shipNominationPeriodRegime: c.shipNominationPeriodRegime,
		shortNotice: c.shortNotice,
		customerNotes: c.customerNotes,
		customerReference: c.customerReference,
		contacts: c.contacts ? Object.entries(c.contacts)
			.filter(([ _, contacts ]) => contacts.length > 0)
			.map(([ roleType, contacts ]) => ({
				contactRoleType: roleType,
				contactIds: contacts.map(c => c.id),
			})) : [],
		voyages: [],
	};
};

export const getApplicableCharterSubtypes = (session, customCharterSubtypes) => {
	const charterSubtypes = customCharterSubtypes || Object.values(CharterSubtype);
	const pluginCharterSubtypes = getMultiValuesField(session, "customCharterSubtypes").trim().length > 0 ?
		getMultiValuesField(session, "customCharterSubtypes").split(";") : [];

	return pluginCharterSubtypes.length > 0 ? charterSubtypes.filter(cs => pluginCharterSubtypes.includes(cs)) : charterSubtypes;
};
